import React, { useEffect, useState } from 'react';
import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import Sidenavigation1 from '../../layouts/Sidenavigation1';
import Topnavigation from '../../layouts/Topnavigation';

import { CurrentSingleContextProvider } from '../../MyContexts/CurrentSingle_Context';
import { MenuContextProvider } from '../../MyContexts/Rest_Context';
import SingleSection from './SingleSection';

const SingleSect = (props) => {

    const [theSection, setTheSection] = useState();

    useEffect(() => {


        if (props.newp) {
            setTheSection(<SingleSection newp={true} upSimplsList={(newitem) => props.upSimplsList(newitem)} />);
        }
        else {
            setTheSection(<SingleSection key={props.pageItem._id}
                pageItem={props.pageItem}
                pageId={props.pageItem._id}
                upSimplsList={(newitem) => props.upSimplsList(newitem)} />);
        }

    }, [props.pageItem])
    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">

            <TheMasterContextProvider>
                <Sidenavigation1 />
                <main className="body-content">
                    <MenuContextProvider>
                        <CurrentSingleContextProvider>
                            <Topnavigation />
                            {theSection}
                        </CurrentSingleContextProvider>
                    </MenuContextProvider>
                </main>
                {/* <Quickbar /> */}
            </TheMasterContextProvider>

        </div>
    );
}

export default SingleSect;